import React from "react"
import styled from "styled-components"
import RoleSummary from "./RoleSummary"
import Befit from "./Befit"

export default function CBlock({ summary, analysis, befit }) {
  return (
    <Wrapper>
      <RoleSummary summary={summary} analysis={analysis} />
      <Befit befit={befit} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (max-width: 1200px) {
    gap: 20px;
  }
`
